export const fmtDate = (iso) => {
  if (!iso) return '';
  const d = iso.toDate ? iso.toDate() : new Date(iso);
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const fmtDateTime = (iso) => {
  if (!iso) return '';
  const d = iso.toDate ? iso.toDate() : new Date(iso);
  return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const nowISO = () => new Date().toISOString();

export const daysDiff = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  d.setHours(0, 0, 0, 0);
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return Math.round((d - t) / (1000 * 60 * 60 * 24));
};

export const stageMeta = (id, STAGES) => STAGES.find(s => s.id === id) || STAGES[0];

export const exportContattiCSV = (contatti) => {
  const headers = ['Nome','Azienda','Telefono','Email','Citta','Tag','Fonte','Stage','Owner','Note'];
  const rows = contatti.map(c => [c.nome, c.azienda, c.telefono, c.email, c.citta, c.tag, c.fonte, c.stage, c.owner, (c.note || '').replace(/\n/g, ' ')]
    .map(v => '"' + (v || '').toString().replace(/"/g, '""') + '"').join(','));
  const csv = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'auctoris_contatti_' + todayISO() + '.csv';
  a.click();
  URL.revokeObjectURL(url);
};
